export enum CustomerStatutoryDiscountStatus {
    EXPIRED = 'expired',
    VALID = 'valid',
    NOT_APPLICABLE = 'not applicable',
}